<template>
  <div v-if="$store.getters['NGUD/isLoggedIn']">
    <span :class="isCiudadano? 'displayNone': ''" id="text-name">{{ $store.getters["NGUD/fullName"] }}</span>
    <q-btn round data-cy="user-menu">
      <q-avatar size="34px">
        <img :src="require('@/assets/img/account_circle.svg')" />
      </q-avatar>

      <q-menu
        :offset="[0, 2]"
        :content-style="{
          borderRadius: '0px',
          marginTop: '1px !important',
        }"
        transition-show="slide-left"
        transition-hide="slide-right"
      >
        <div class="containerMenu">
          <q-list class="text-primary listItems">
            <q-item clickable v-ripple data-cy="user-option" @click="_goProfilePage()">
              <q-item-section avatar>
                <q-avatar size="34px" class="imgCenter">
                  <img :src="require('@/assets/img/account_circle_blue.svg')" />
                </q-avatar>
              </q-item-section>
              <q-item-section>
                {{ $store.getters["NGUD/userMail"] }}
              </q-item-section>
            </q-item>

            <q-item
              v-if="!isCiudadano"
              clickable
              v-ripple
              @click="_changePassword()"
              data-cy="user-changepassword"
            >
              <q-item-section avatar>
                <q-avatar size="24px" class="imgCenter">
                  <img :src="require('@/assets/img/inbox.svg')" />
                </q-avatar>
              </q-item-section>
              <q-item-section>Cambiar contraseña</q-item-section>
            </q-item>

            <q-item clickable v-ripple @click="_logout()" data-cy="user-logout">
              <q-item-section avatar>
                <q-avatar size="24px" class="imgCenter">
                  <img :src="require('@/assets/img/highlight_off.svg')" />
                </q-avatar>
              </q-item-section>
              <q-item-section>Cerrar sesión</q-item-section>
            </q-item>
          </q-list>
        </div>
      </q-menu>
    </q-btn>
    <q-dialog v-model="modalPassword">
      <q-card
        class="shadow-10-disabled flat bordered card-login"
        v-show="isExternal"
        data-cy="changepassword-external"
      >
        <q-card-section>
          <div class="text-h6">Cambio de Contraseña</div>
        </q-card-section>
        <q-card-section class="q-mt-md q-mr-sm">
          <q-input
            minlength="6"
            maxlength="100"
            hint="6 caracteres mínimo. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
            v-model="$v.Contraseña.$model"
            outlined
            :error="$v.Contraseña.$error"
            label="Introduce tu nueva contraseña"
            debounce="0"
            bottom-slots
            :type="isPwd ? 'password' : 'text'"
            :rules="[
              (val) =>
                validatePassword(val) ||
                'Contraseña no válida. 6 caracteres mínimo, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
            ]"
          >
            <template
v-slot:error
              >Dato Obligatorio. 6 caracteres mínimo, se requiere al menos 1
              número, 1 letra minúscula y 1 mayúscula.</template
            >
            <template v-slot:append>
              <q-icon
                :name="isPwd ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="isPwd = !isPwd"
              />
            </template>
          </q-input>
        </q-card-section>
        <q-card-section class="q-mt-md q-mr-sm">
          <q-input
            minlength="6"
            maxlength="100"
            required
            hint="6 caracteres mínimo. Requiere al menos 1 número, 1 letra minúscula y 1 mayúscula"
            outlined
            debounce="0"
            :error="$v.RepetirContraseña.$error"
            :rules="[
              (val) =>
                val === this.Contraseña || 'Las contraseñas deben coincidir',
              (val) =>
                validatePassword(val) ||
                'Contraseña no válida. 6 caracteres mínimo, se requiere al menos 1 número, 1 letra minúscula y 1 mayúscula',
            ]"
            v-model="$v.RepetirContraseña.$model"
            :type="isPwd2 ? 'password' : 'text'"
            label="Confirmar Contraseña"
            bottom-slots
          >
            <template
v-slot:error
              >Dato Obligatorio. 6 caracteres mínimo, se requiere al menos 1
              número, 1 letra minúscula y 1 mayúscula.</template
            >
            <template v-slot:append>
              <q-icon
                :name="isPwd2 ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="isPwd2 = !isPwd2"
              />
            </template>
          </q-input>
        </q-card-section>
        <q-card-actions class="q-mt-md q-mr-sm" align="right">
          <q-btn
            flat
            label="Cancelar"
            data-cy="cancel-changepassword"
            padding="xs lg"
            v-close-popup
            @click="clearData()"
          />
          <q-btn
            style="width: 40%; margin-left: 0 !important"
            @click="validar"
            color="primary"
            padding="xs lg"
            >Enviar</q-btn
          >
        </q-card-actions>
      </q-card>

      <q-card v-show="!isExternal" data-cy="changepassword-internal">
        <q-card-section>
          <div class="text-h6">Cambio de Contraseña</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Para poder modificar su contraseña debe de ir al autoservicio de
          contraseña.
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancelar" padding="xs lg" v-close-popup />
          <q-btn
            flat
            label="OK"
            padding="xs lg"
            color="primary"
            v-close-popup
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { required, sameAs } from 'vuelidate/lib/validators';
import { QAvatar, QMenu, QDialog } from 'quasar';
import Validation from '@/components/shared/mixins/Validation.js';
import Message from '@/components/shared/mixins/Message.js';
import * as AuthService from '@/services/AuthService.js';
import { mapGetters } from 'vuex';

export default {
  mixins: [Validation, Message],
  computed: {
    ...mapGetters({
      isCiudadano: 'NGUD/isCiudadano'
    })
  },
  validations: {
    Contraseña: { required },
    RepetirContraseña: { required, sameAsPassword: sameAs('Contraseña') }
  },
  created () {
  },
  data () {
    return {
      modalPassword: false,
      isExternal: this.$store.getters['NGUD/isExternal'],
      isPwd: true,
      isPwd2: true,
      Contraseña: null,
      RepetirContraseña: null
    };
  },
  components: {
    QAvatar,
    QMenu,
    QDialog
  },
  methods: {
    _goProfilePage () {
      AuthService.goAccountURL();
    },
    clearData () {
      this.Contraseña = '';
      this.RepetirContraseña = '';
      this.$v.$reset();
    },
    async validar () {
      this.$v.$touch();

      if (
        this.$v.$error ||
        !this.comprobarContraseñas(this.Contraseña, this.RepetirContraseña)
      ) {
        this.showError('Deben introducirse correctamente todos los datos.');
      } else {
        let dataArray = {};
        dataArray = {
          password: this.Contraseña
        };

        let request = {
          controller: `/User/${this.$store.getters['NGUD/userId']}/reset-password`,
          filter: {},
          body: dataArray
        };

        await this.$store
          .dispatch('NGUD/putSuit', request)
          .then((response) => {
            this.showMessage('Su contraseña se ha modificado con éxito.');
            this.modalPassword = false;
          })
          .catch((err) => {
            this.showError(err.message);
          });
      }
    },
    _logout () {
      this.$store.commit('NGUD/setCiudadSelected', null);
      localStorage.clear();
      this.setRoute();
      AuthService.logout();
    },
    _changePassword () {
      this.clearData();
      this.modalPassword = true;
    },
    setRoute (params = {}) {
      const slug = params.slug || '/';
      window.history.pushState(null, null, slug);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/style.scss";

.card-login {
  border-radius: 12px;
  max-width: 422px;
  min-width: 350px;
  width: 422px;
}
.displayNone {
  display: none;
}
#text-name {
  margin-right: 22px;
}
</style>
